module.exports = __webpack_public_path__ + "28c2f126c67239940ce719dc477da565.png";